import { render, staticRenderFns } from "./channelCustomerMonitor.vue?vue&type=template&id=26ef45b2&scoped=true"
import script from "./channelCustomerMonitor.vue?vue&type=script&lang=js"
export * from "./channelCustomerMonitor.vue?vue&type=script&lang=js"
import style0 from "./channelCustomerMonitor.vue?vue&type=style&index=0&id=26ef45b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ef45b2",
  null
  
)

export default component.exports